import React, { useLayoutEffect } from 'react';
import {fromEvent} from "rxjs";
import {startWith} from "rxjs/operators";

import FullscreenImageContainer from "#app/components/UI/FullscreenImageContainer";

import {Container} from "./styles";

type GridContainerProps = {
    children: any;
    containerComponent?: typeof Container;
    [key: string]: any;
};

const GridContainer = (
    {
        children,
        containerComponent: ContainerComponent = Container,
        ...props
    }: GridContainerProps
): any => {
    const onResize: (e?: any) => void = (): void => {
        const element: HTMLElement|null = document.getElementById('grid-container');

        if (element) {
            const parentHeight: number = window.innerHeight;

            const diff: string = (parentHeight - 90) + 'px';

            element.style.height = diff;
            element.style.maxHeight = diff;
        }
    };

    useLayoutEffect((): () => void => {
        const resizeSubscription = fromEvent(window, "resize")
            .pipe(startWith(null))
            .subscribe(() => {
                onResize();
            });

        return () => {
            resizeSubscription.unsubscribe();
        };
    }, []);

    return (
        <ContainerComponent id='grid-container' {...props}>
            <FullscreenImageContainer />
            {children}
        </ContainerComponent>
    )
};

export default GridContainer;
